<template>
  <div class="relative bg-white pt-16 pb-16">
    <div class="px-4 md:px-10 mx-auto w-full">
      <!-- 表格 -->
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">放弃创建监控</h3>
                </div>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
              <div class="flex flex-wrap items-center gap-3 mb-4">
                <div class="flex items-center">
                  <span class="text-sm text-blueGray-600 mr-2">UID筛选:</span>
                  <input
                    type="text"
                    v-model="searchUid"
                    placeholder="请输入用户ID"
                    class="border border-blueGray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    @keyup.enter="handleSearch"
                  />
                </div>
                <button
                  @click="handleSearch"
                  class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded text-sm"
                  type="button"
                >
                  查询
                </button>
                <button
                  @click="resetSearch"
                  class="bg-white hover:bg-blueGray-50 text-blueGray-700 font-bold py-2 px-4 rounded text-sm border border-blueGray-200"
                  type="button"
                >
                  重置
                </button>
              </div>
              <div class="block w-full overflow-x-auto md:overflow-visible">
              <el-table
                :data="abandonList"
                style="width: 100%"
                stripe
                border
                highlight-current-row
                v-loading="loading"
              >
                <el-table-column prop="uid" label="用户ID" width="200">
                  <template #default="scope">
                    <span class="font-medium">{{ scope.row.uid }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="source" label="来源" width="140">
                  <template #default="scope">
                    <el-tag size="small" type="info">{{ scope.row.source || '-' }}</el-tag>
                  </template>
                </el-table-column>

                <el-table-column prop="ip" label="IP" width="140">
                  <template #default="scope">
                    <span class="text-sm font-mono">{{ scope.row.ip || '-' }}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="create_time" label="添加时间" width="180">
                  <template #default="scope">
                    {{ formatDate(scope.row.create_time) }}
                  </template>
                </el-table-column>

                <el-table-column prop="activity_type" label="活动类型" width="140">
                  <template #default="scope">
                    <el-tag size="small" :type="getActivityTypeTag(scope.row.activity_type)">
                      {{ scope.row.activity_type || '-' }}
                    </el-tag>
                  </template>
                </el-table-column>

                <el-table-column prop="contact_mobile" label="联系电话" width="140">
                  <template #default="scope">
                    <span class="text-sm font-mono">{{ scope.row.contact_mobile || '-' }}</span>
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="100" fixed="right">
                  <template #default="scope">
                    <el-button type="primary" size="small" @click="showUserDetail(scope.row)">
                      用户详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              </div>
              <el-pagination
                :current-page="currentPage"
                :page-size="pageSize"
                :page-sizes="[10, 20, 50, 100]"
                :total="totalRecords"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                class="flex justify-center mt-4"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 用户详情弹窗 -->
    <el-dialog
      v-model="userDialogVisible"
      title="用户详情"
      width="700px"
      :close-on-click-modal="false"
    >
      <user-profile
        v-if="userDialogVisible"
        :uid="currentUid"
        :user-info="currentUserInfo"
        :visit-log-list="currentVisitLogList"
        @refresh-visit-log="refreshVisitLog"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getAdminApiUrl } from "@/api/luckdraw.js";
import { getUserToken } from "@/utils/auth.js";
import UserProfile from "@/components/User/UserProfile.vue";

export default {
  name: "CreateAbandon",
  components: {
    UserProfile
  },
  data() {
    return {
      abandonList: [],
      loading: false,
      searchUid: "",
      currentPage: 1,
      pageSize: 20,
      totalRecords: 0,
      userDialogVisible: false,
      currentUid: null,
      currentUserInfo: {},
      currentVisitLogList: []
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const token = getUserToken();
        const response = await fetch(getAdminApiUrl('/stat/daily/quit/create'), {
          method: 'POST',
          headers: {
            'Token': `${token}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({
            page: this.currentPage,
            page_size: this.pageSize,
            uid: this.searchUid || undefined
          })
        });
        const result = await response.json();
        if (result.sta === 0 && result.data) {
          this.abandonList = result.data.items || [];
          this.totalRecords = result.data.count || 0;
        }
      } catch (error) {
        console.error('加载数据失败:', error);
      } finally {
        this.loading = false;
      }
    },

    async showUserDetail(row) {
      this.currentUid = row.uid;
      this.userDialogVisible = true;
      this.currentUserInfo = {};
      this.currentVisitLogList = [];

      // 获取用户详情
      try {
        const token = getUserToken();
        const response = await fetch(getAdminApiUrl('/user/profile'), {
          method: 'POST',
          headers: {
            'Token': `${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ uid: row.uid })
        });
        const result = await response.json();
        if (result.sta === 0 && result.data) {
          this.currentUserInfo = result.data;
        }
      } catch (error) {
        console.error('获取用户详情失败:', error);
      }

      // 获取跟进记录
      try {
        const token = getUserToken();
        const response = await fetch(getAdminApiUrl('/user/visit/list'), {
          method: 'POST',
          headers: {
            'Token': `${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ uid: row.uid, page: 1, page_size: 20 })
        });
        const result = await response.json();
        if (result.sta === 0 && result.data) {
          this.currentVisitLogList = result.data.items || [];
        }
      } catch (error) {
        console.error('获取跟进记录失败:', error);
      }
    },

    async refreshVisitLog() {
      if (!this.currentUid) return;
      try {
        const token = getUserToken();
        const response = await fetch(getAdminApiUrl('/user/visit/list'), {
          method: 'POST',
          headers: {
            'Token': `${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ uid: this.currentUid, page: 1, page_size: 20 })
        });
        const result = await response.json();
        if (result.sta === 0 && result.data) {
          this.currentVisitLogList = result.data.items || [];
        }
      } catch (error) {
        console.error('刷新跟进记录失败:', error);
      }
    },

    formatDate(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    getActivityTypeTag(type) {
      const typeMap = {
        '抽奖活动': 'success',
        '签到活动': 'warning',
        '答题活动': 'info',
        '红包活动': 'danger'
      };
      return typeMap[type] || 'info';
    },

    handleSearch() {
      this.currentPage = 1;
      this.loadData();
    },

    resetSearch() {
      this.searchUid = "";
      this.currentPage = 1;
      this.loadData();
    },

    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadData();
    },

    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },

    refreshData() {
      this.currentPage = 1;
      this.loadData();
    }
  },
};
</script>
